/**
 * Extracts market slug from various input formats (URL, slug, query params)
 */
export function extractMarketSlug(input: string | undefined): string {
  try {
    let raw = String(input || '').trim();
    if (!raw) return '';
    // Allow leading '@' pasted from chats
    if (raw.startsWith('@')) raw = raw.slice(1);
    // Direct ?slug=... query string
    const slugParam = /[?&]slug=([^&#]+)/i.exec(raw);
    if (slugParam?.[1]) {
      return decodeURIComponent(slugParam[1]);
    }
    // If looks like a URL (or missing scheme but has domain), use URL parsing
    const looksLikeUrl =
      /^(https?:)?\/\//i.test(raw) ||
      /polymarket\.com\//i.test(raw) ||
      /gamma-api\.polymarket\.com\//i.test(raw);
    if (looksLikeUrl) {
      const u = new URL(raw.startsWith('http') ? raw : `https://${raw}`);
      // Gamma API link with slug param
      const qsSlug = u.searchParams.get('slug');
      if (qsSlug) return qsSlug;
      // event route: /event/<slug>[/<submarket>]
      const parts = u.pathname.split('/').filter(Boolean);
      const idx = parts.findIndex((p) => p.toLowerCase() === 'event');
      if (idx >= 0 && parts[idx + 1]) {
        const base = decodeURIComponent(parts[idx + 1]!);
        const sub = parts[idx + 2] ? decodeURIComponent(parts[idx + 2]!) : '';
        if (sub) {
          // Map common Polymarket submarket URL forms to Gamma slugs
          const m = /-(game|map)(\d+)$/i.exec(sub);
          if (m && m[1] && m[2]) {
            const n = m[2];
            return `${base}-game-${n}-winner`;
          }
          if (sub.startsWith(base + '-')) return sub;
          return base;
        }
        return base;
      }
      // fallback: last non-empty segment
      if (parts.length > 0) return decodeURIComponent(parts[parts.length - 1]!);
    }
    // Otherwise assume it's already a slug
    return raw;
  } catch (err) {
    console.warn('[slug] Failed to extract slug:', err);
    return String(input || '').trim();
  }
}


